module.exports = __webpack_public_path__ + "static/media/loading_spinner.a40839d9.gif";